import styled from 'styled-components';

export const AccomodationMealPlanContainer = styled.div`
  width: 48px;
  height: 48px;
  min-height: 48px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.3s ease-in-out;
`;

export const AccomodationMealPlanName = styled.div`
  width: 100%;
  white-space: normal;
  text-align: center;
  line-height: 15px;
  margin-top: 8px;
`;
